import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=37fadd24&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"
import style0 from "./theme.vue?vue&type=style&index=0&id=37fadd24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fadd24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fadd24')) {
      api.createRecord('37fadd24', component.options)
    } else {
      api.reload('37fadd24', component.options)
    }
    module.hot.accept("./theme.vue?vue&type=template&id=37fadd24&scoped=true", function () {
      api.rerender('37fadd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents-cool/theme.vue"
export default component.exports